export class ModalSolicitacaoExistenteController {
  constructor($scope, $uibModalInstance) {
    'ngInject';

    $scope.close = () => {
      $uibModalInstance.dismiss('cancel');
    };
  }
}
